import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BookmarksIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bookmarks"}/>
}
